<script>
import Multiselect from "vue-multiselect";

import VolumeForm from "./volume-form";
import PageImage from "../pages/page-image";
import api from "../../services/api";


/**
 * Nav-bar Component
 */
export default {
  components: {
    VolumeForm,
    PageImage,
    Multiselect,
  },
  props: {
    album: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      isLoading: true,
      listPages: [],
    };
  },
  mounted() {
    this.getPages();
  },
  methods: {
    async getPages() {
      if (this.album.pages === undefined) {
        this.album.pages = await api.get('pages', {
          page: 1,
          length: 300,
          sortBy: 'NumPageAlbum',
          sortDir: 'asc',
          albums: this.album.id
        }).then((response) => {
          return response.data.data;
        });
      }

      this.setListPages();
      this.isLoading = false;
    },
    setListPages() {
      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page))
          this.listPages.push(this.album.pages[page].NumPageAlbum);
      }
    },
    getImageFromNumPageAlbum(numPageAlbum) {
      let pageFound = null;

      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page) && this.album.pages[page].NumPageAlbum === numPageAlbum) {
          pageFound = this.album.pages[page];
          break;
        }
      }

      return pageFound;
    },
    async submitForm() {
      api.save('albums', this.album)
          .then((response) => {
            if (response.code !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
  }
};
</script>

<template>
  <b-form>
    <b-card no-body>
      <b-row no-gutters class="align-items-center">
        <b-col md="4">
          <page-image :page="getImageFromNumPageAlbum(album.thumbnails_album)"></page-image>
        </b-col>
        <b-col md="8">
          <b-card-body>
            <b-row class="mb-3">
              <b-col md="3">
                <b-form-group label="Numéro d'inventaire" label-for="formrow-num_inventaire-input">
                  <b-form-input id="formrow-num_inventaire-input" type="text"
                                v-model="album.num_inventaire"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Titre" label-for="formrow-titre-input">
                  <b-form-input id="formrow-titre-input" type="text" v-model="album.titre"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Page d'illustration" label-for="formrow-thumbnails_album-input">
                  <multiselect
                      id="formrow-thumbnails_album-input"
                      v-model="album.thumbnails_album"
                      :options="listPages"
                      :loading="isLoading"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <b-row no-gutters class="align-items-center">
      <b-col>
        <h4>{{ 'Volume' + (album.volumes.length > 0 ? 's' : '') }}</h4>
        <b-row>
          <b-col class="pe-0">
            <ul class="list-unstyled chat-list" v-if="!isLoading">
              <li>
                <a>
                  <div class="media-body">
                    <volume-form :album="album"></volume-form>
                  </div>
                </a>
              </li>
              <li
                  v-for="volume in album.volumes"
                  :key="volume.id"
              >
                <a>
                  <div class="media-body">
                    <volume-form :album="volume"></volume-form>
                  </div>
                </a>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>
